import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

import { FavoriteProduct, FavoriteProductType } from '../query/loadUserQuery';

// Параметры мутации добавление продукта в избранное
export interface AddFavoritesProductMutationParams {
  type: FavoriteProductType;
  data: string;
}

// Ответ мутации добавление продукта в избранное
export interface AddFavoritesProductMutationResponse {
  data: FavoriteProduct;
}

// Мутация на добавление продукта в избранное
export class AddFavoritesProductMutation
  implements GraphQLQuery<AddFavoritesProductMutationParams>
{
  readonly query: any;

  readonly variables: AddFavoritesProductMutationParams;

  constructor(params: AddFavoritesProductMutationParams) {
    this.variables = {
      ...params,
    };

    this.query = gql`
      mutation __ADD_PRODUCT_TO_FAVORITES__($type: BitrixUserFavouriteTypeEnum!, $data: String!) {
        data: BitrixUserAddFavourite(type: $type, data: $data) {
          data
          id
          type
          userID
        }
      }
    `;
  }
}
